import { render, staticRenderFns } from "./ArchiveAdmin.vue?vue&type=template&id=cc274d6a"
import script from "./ArchiveAdmin.vue?vue&type=script&lang=js"
export * from "./ArchiveAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports